import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getPreCompLocationStaffData from '@usas/ui-web/state/orgUnitStaff/GetOrgUnitStaffData';
import postPreCompLocationStaffData from '@usas/ui-web/state/orgUnitStaff/PostOrgUnitStaffData';
import putPreCompLocationStaffData from '@usas/ui-web/state/orgUnitStaff/PutOrgUnitStaffData';
import deletePreCompLocationStaffData from '@usas/ui-web/state/orgUnitStaff/DeletePersonOrgRoleDurationData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const PreCompLocationStaffData = { INITIAL_STATE, getPreCompLocationStaffData, postPreCompLocationStaffData, putPreCompLocationStaffData, deletePreCompLocationStaffData };

export default PreCompLocationStaffData;